<template>
<div>
    <header>
        <h1>Registrieren</h1>
    </header>
    <custom-form :fields="[ 'username', 'email', 'firstname', 'lastname', 'password', 'password_repeat' ]"
          submitLabel="Registrieren" 
          secondaryLabel="Bestehendes Konto verwenden"
          url="signup"
          @submitted="signedUp()" 
          @secondary="login()" />
</div>
</template>

<script>
import base from 'base.vue'
import customForm from 'components/custom-form.vue'

export default {
    mixins: [ base ],
    components: { customForm },
    data () {
        return { }
    },
    methods: {
        signedUp () {
            window.router.push('/signup-complete')
        },
        login () {
            window.router.push('/login')
        }
    }
}
</script>



// WEBPACK FOOTER //
// signup.vue?33a4972e